import { gql } from "graphql-tag";

export const INTEREST_LIST_PAGE_TITLE = gql`
  query InterestListPageTitle($id: ID!) {
    interestList(id: $id) {
      id
      name
    }
  }
`;
